import { Routes } from "@angular/router";
import { AuthenticationGuard, AuthorizationGuard } from "@softline/auth";
import { importProvidersFrom } from "@angular/core";
import { ConnectionHttpService, StoreModule } from "@softline/core";
import { EntityGuard } from "./guard/entity.guard";
import { SOFTLINE_FEATURE_PRODUCT_SCAN, SOFTLINE_PERMISSION_ARTIKELINFO } from "./product-scan.shared";
import { ProductStore } from "./store/product.store";
import { ProductResourceService } from "./services/product-resource.service";

export const artikelinfoRoutes: Routes = [
  {
    path: 'artikelinfo',
    loadComponent: () => import('./components/product-scan.component').then(o => o.ProductScanComponent),
    children: [
      { path: 'item', loadComponent: () => import('./components/product-detail/product-detail.component').then(o => o.ProductDetailComponent), canActivate: [EntityGuard] },
      { path: '', loadComponent: () => import('./components/find-product/find-product.component').then(o => o.FindProductComponent) },
      { path: '**', redirectTo: '/artikelinfo' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_ARTIKELINFO},
    providers: [
      ProductResourceService,
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_PRODUCT_SCAN,
          feature: ProductStore.feature,
          providers: [
            {
              provide: ProductResourceService,
              useFactory: (service: ConnectionHttpService) => new ProductResourceService(service),
              deps: [ConnectionHttpService]
            }
          ]
        }),
      ),
    ]
  },
];
